/* eslint-disable react/prop-types */
import React from 'react'
import { useSvg } from '../../hooks'

/**
 * @function
 * @description AlertWarning
 * @param {object} props props.
 * @param {string} props.fill Fill color for the icon. By default, it picks up the color of the nearest parent.
 * @param {number} props.scale Scale for the size of the icon. The default is 1.
 * @returns {object} svg of the icon
 */
export default props => {
  const viewBoxWidth = 24
  const viewBoxHeight = 24
  const [, width, height] = useSvg(props, viewBoxWidth, viewBoxHeight)
  return (
    <svg width={width} height={height} viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`} version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <g id="Group_2073" data-name="Group 2073" transform="translate(-138.601 -1455)">
        <g id="Boundary" transform="translate(138.601 1455)" stroke="rgba(0,0,0,0)" strokeWidth="1" opacity="0">
          <rect width="24" height="24" stroke="none"/>
          <rect x="0.5" y="0.5" width="23" height="23" fill="none"/>
        </g>
        <path id="Path_alert-outline" data-name="Path / alert-outline" d="M12,2,1,21H23M12,6l7.53,13H4.47M11,10v4h2V10m-2,6v2h2V16" transform="translate(138.601 1456)" fill={PushSubscriptionOptions.fill || '#ffa420'} />
      </g>
    </svg>
  )
}
